var map = {
	"./amex.svg": 7260,
	"./diners.svg": 58898,
	"./discover.svg": 55932,
	"./jcb.svg": 17142,
	"./mastercard.svg": 79793,
	"./unionpay.svg": 18512,
	"./unknown.svg": 35581,
	"./visa.svg": 39046,
	"./wrong.svg": 9012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15946;